/**
 * Author: Romain Hapi Sr.
 * Version: 1.0
 * Date: 2026-09-10
 * Project: Prenim Digital
 * Copyright: Prenim UK
 */
/**
 * Jetons de style de la section Tchad.
 *
 * Les sept pages divergeaient : chacune redefinissait ses cartes, ses degrades
 * et ses boutons. Tout passe desormais par ce fichier, pour que la refonte
 * d'une page ne desaccorde pas les autres.
 *
 * Direction : Swiss corporate haut contraste (cf. design_guidelines.json),
 * base slate commune au UK, signature or/ambre propre au Tchad.
 */

// Conteneur de page. `max-w-site` vaut 1664 px, partage avec le site UK.
export const SHELL = 'max-w-site mx-auto px-4 sm:px-6 lg:px-8';

// Rythme vertical. La charte demande py-20 a py-32.
export const SECTION = 'py-24 lg:py-32';

// Surtitre : petites capitales espacees, or sur fond sombre, ambre-600 sur clair.
export const EYEBROW_DARK =
  'text-xs font-semibold uppercase tracking-widest text-amber-400';
export const EYEBROW_LIGHT =
  'text-xs font-semibold uppercase tracking-widest text-amber-600';

// Echelle typographique de la charte.
export const H1 =
  'text-4xl sm:text-5xl lg:text-7xl font-bold tracking-tight leading-[1.05]';
export const H2 =
  'text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.1]';
export const H3 = 'text-xl sm:text-2xl font-semibold tracking-tight';
export const LEAD = 'text-lg text-slate-600 leading-relaxed';
export const LEAD_DARK = 'text-lg text-slate-300 leading-relaxed';

// Cartes : bordure 1px, angles doux, ombre discrete. Pas de shadow-2xl.
export const CARD =
  'rounded-lg border border-slate-200 bg-white shadow-sm transition-[transform,border-color,box-shadow] duration-300 ' +
  'hover:-translate-y-1 hover:border-slate-300 hover:shadow-md';
export const CARD_DARK =
  'rounded-lg border border-white/10 bg-white/[0.03] transition-[transform,border-color,background-color] duration-300 ' +
  'hover:-translate-y-1 hover:border-amber-400/40 hover:bg-white/[0.06]';

// Boutons. Le primaire porte l'or ; le texte reste slate-950 pour le contraste.
export const BTN_PRIMARY =
  'inline-flex items-center gap-2 rounded-md bg-amber-500 px-6 py-3 font-semibold text-slate-950 ' +
  'transition-colors hover:bg-amber-400 focus-visible:outline focus-visible:outline-2 ' +
  'focus-visible:outline-offset-2 focus-visible:outline-amber-400';
export const BTN_ON_DARK =
  'inline-flex items-center gap-2 rounded-md border-2 border-white/25 px-6 py-3 font-semibold text-white ' +
  'transition-colors hover:border-amber-400 hover:text-amber-400 focus-visible:outline ' +
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-400';
export const BTN_ON_LIGHT =
  'inline-flex items-center gap-2 rounded-md border-2 border-slate-950 px-6 py-3 font-semibold text-slate-950 ' +
  'transition-colors hover:bg-slate-950 hover:text-white focus-visible:outline focus-visible:outline-2 ' +
  'focus-visible:outline-offset-2 focus-visible:outline-slate-950';

// Filet or place sous un surtitre ou en tete de bloc.
export const RULE = 'tchad-rule';
